import Component from "../../lib/component";
import {TogglerBtnConfig, TogglerBtn} from "./toggler_btn";
import {TogglerWrap} from "./toggler_wrap";
import {TogglerPanes} from "./toggler_panes";
import {getThrottledFunction} from "../../helpers/throttle";
import {UrlHashManager} from "../../lib/url_hash_manager";

export const TogglerBtnsConfig = {
    componentTypeKey: 'TogglerBtns',
    baseHtmlClass: 'toggler_btns',
    selector: '.toggler_btns',

    wrapSelector: '.toggler_btns_wrap',
    btnSelector: TogglerBtnConfig.selector,

    panesElementIdDatasetKey: 'toggler_btns__panes_id',
    panesHeightDatasetKey: 'toggler_btns__panes_height',
    urlStoreEnabledDatasetKey: 'toggler_btns__url_store',
};


export class TogglerBtns extends Component {

    static get config() {
        return TogglerBtnsConfig;
    }

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: TogglerBtnsConfig
        });

        this.urlStoreEnabled = this.element.dataset[TogglerBtnsConfig.urlStoreEnabledDatasetKey] === 'true';

        this.urlHashManager = (this.urlStoreEnabled) ? new UrlHashManager(this.element, this.urlHashKey) : null;

        this.togglerWrap = getTogglerWrap(this);
        this.childTogglerBtns = getChildTogglerBtns(this);
        this.togglerPanes = getTogglerPanes(this);

        this.isMultiline = this.calcIsMultiline();

        if (this.urlStoreEnabled) window.addEventListener('hashchange', this.handleUrlHash.bind(this));

        const resizeHandler = getThrottledFunction(this.handleResize.bind(this), 100);
        this.observer = new ResizeObserver(resizeHandler);
        this.observer.observe(this.element);
        this.handleResize();

        this.handleUrlHash();
        this.activateInitialTogglerBtn();
    }

    get urlHashKey() {
        return `${TogglerBtns.config.baseHtmlClass}--${this.id}`;
    }

    setUrlHashForPaneId(paneId) {
        if (!paneId) return;
        if (!this.urlHashManager) return;
        this.urlHashManager.setValue(paneId);
    }

    getPaneIdFromUrlHash() {
        if (!this.urlHashManager) return;
        return this.urlHashManager.getValue();
    }

    getTogglerBtnForPaneId(paneId) {
        if (!paneId) return;
        return this.childTogglerBtns.find((togglerBtn) => {
            return togglerBtn.togglerPane.id === paneId;
        });
    }

    handleUrlHash(event) {
        if (!this.urlStoreEnabled) return;
        const paneIdFromUrlHash = this.getPaneIdFromUrlHash();
        const togglerBtn = this.getTogglerBtnForPaneId(paneIdFromUrlHash);
        if (togglerBtn) this.activateBtn(togglerBtn);
    }

    handleResize(event) {
        this.isMultiline = this.calcIsMultiline();
        this.render();
    }

    deactivateBtns() {
        this.childTogglerBtns.forEach((togglerBtn) => {
            togglerBtn.deactivate()
        });
    }

    activateBtn(togglerBtn) {
        this.deactivateBtns();
        togglerBtn.activate();
    }

    activateInitialTogglerBtn() {
        let activeTogglerBtn = null;
        this.childTogglerBtns.forEach((togglerBtn) => {
            if (togglerBtn.isActive) activeTogglerBtn = togglerBtn;
        });
        // If there is no existing active toggler btn then we activate the first one.
        if (!activeTogglerBtn) {
            let firstTogglerBtn = this.childTogglerBtns[0];
            this.activateBtn(firstTogglerBtn);
        }
    }

    calcIsMultiline() {
        const childTogglerBtnHeight = this.childTogglerBtns[0].element.offsetHeight;
        const height = this.element.offsetHeight;
        return height >= (childTogglerBtnHeight * 2);
    }

    render() {
        this.conditionallySetHtmlClassState(this.isMultiline, 'multiline');
    }

}

function getTogglerWrap(togglerBtns) {
    const wrapElement = togglerBtns.element.closest(TogglerBtnsConfig.wrapSelector);
    return new TogglerWrap(wrapElement, togglerBtns);
}

function getChildTogglerBtns(togglerBtns) {
    const btnElements = togglerBtns.element.querySelectorAll(TogglerBtnsConfig.btnSelector);
    let childTogglerBtns = [];
    btnElements.forEach((btnElement) => {
        childTogglerBtns.push(new TogglerBtn(btnElement, togglerBtns));
    });
    return childTogglerBtns;
}

function getTogglerPanes(togglerBtns) {
    const panesElementId = togglerBtns.element.dataset[TogglerBtnsConfig.panesElementIdDatasetKey];
    const panesElement = document.getElementById(panesElementId);
    return new TogglerPanes(panesElement, togglerBtns);
}
